import "./Stats.css";
import { useEffect, useState } from "react";

const statsData = [
  { id: 1, label: "# Cookies Sold 🍪", total: 253 },
  { id: 2, label: "Total Charity Donations 💛", total: 10 },
  { id: 3, label: "Local Markets Attended 🏪", total: 2 },
];

function Stats() {
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);

  const animateNumber = (total, index, duration = 2000) => {
    const startTime = performance.now();

    const step = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = Math.floor(total * progress);
      setCounts((prev) => {
        const newCounts = [...prev];
        newCounts[index] = value;
        return newCounts;
      });
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  };

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("stats-section");
      if (!section || hasAnimated) return;

      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        statsData.forEach((stat, index) => {
          animateNumber(stat.total, index, 2000);
        });
        setHasAnimated(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasAnimated]);

  return (
    <section id="stats-section" className="stats-section">
      {statsData.map((stat, index) => (
        <div key={stat.id} className="stat">
          <div className="stat-number">
            {stat.label.includes("Charity Donations")
              ? `$${counts[index].toLocaleString()}`
              : counts[index].toLocaleString()}
          </div>
          <div className="stat-label">{stat.label}</div>
        </div>
      ))}
    </section>
  );
}

export default Stats;
